import AuthService from './authService';

const url = `${process.env.REACT_APP_API_CONNECTION_ROOT}gvdate`;
const authService = new AuthService();

export default class GvDateService {
  getGvDate() {
    return fetch(url, {method: 'GET'})
        .then((response) => {
          if (!response.ok) {
            throw new Error('Request failed with status ' + response.status);
          }
          return response.json();
        })
        .catch((error) => {
          throw error;
        });
  }

  setGvDate(gvDate) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authService.getToken()}`,
      },
      body: JSON.stringify({gvDate}),
    };

    return fetch(url, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Request failed with status ' + response.status);
          }
        })
        .catch((error) => {
          throw error;
        });
  }
}
